import request from '@/utils/request'

export function fetchList(data) {
  return request({
    url: 'api/adopt/adoptlist/list',
    method: 'post',
    data
  })
}